import ProjectCard from './ProjectCard';
import { projects } from '../constants';

function WorkSection() {
  return (
    <section id="work" className="py-12 md:py-16 px-6 md:px-12 max-w-container mx-auto pt-32">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8">
        {projects.map((project, index) => (
          <ProjectCard key={project.id} {...project} delay={0.2 + index * 0.1} />
        ))}
      </div>
    </section>
  );
}

export default WorkSection;

